import type { VoidFunctionComponent } from 'react';

import { OIDCProviderScope } from '../../../../../shared/model-typings/oidcprovider';
import type { OIDCTrustRelationship } from '../../../../../shared/model-typings/oidctrustrelationship';

import styles from './DetailsDrawer.module.less';

type TrustRelationshipDetailsDrawerProps = {
  trustRelationship: OIDCTrustRelationship;
};

const TrustRelationshipDetailsDrawer: VoidFunctionComponent<TrustRelationshipDetailsDrawerProps> = ({
  trustRelationship,
}) => {
  return (
    <div>
      <h2 className={styles.title}>Trust Relationship Details</h2>

      <div className={styles.section}>
        <div className={styles.field}>
          <span className={styles.label}>ID</span>
          <div className={styles.value}>{trustRelationship.id}</div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>User ID</span>
          <div className={styles.value}>{trustRelationship.userId}</div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Provider ID</span>
          <div className={styles.value}>{trustRelationship.providerId}</div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Scope</span>
          <div className={styles.value}>
            {trustRelationship.scope === OIDCProviderScope.ORG ? 'Organization' : 'Team'}
          </div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Scope ID</span>
          <div className={styles.value}>{trustRelationship.scopeId}</div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Organization ID</span>
          <div className={styles.value}>{trustRelationship.organizationId}</div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Audiences</span>
          <div className={styles.value}>
            {trustRelationship.audiences.length > 0
              ? trustRelationship.audiences.join(', ')
              : 'None'}
          </div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Required Claims</span>
          <div className={styles.value}>
            {trustRelationship.requiredClaims.length > 0 ? (
              <ul className={styles.list}>
                {trustRelationship.requiredClaims.map(({ claim, value, hasWildcards }) => (
                  <li key={claim}>
                    <strong>{claim}</strong>: {String(value)}
                    {hasWildcards && ' (wildcards)'}
                  </li>
                ))}
              </ul>
            ) : (
              'None'
            )}
          </div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Created At</span>
          <div className={styles.value}>
            {new Date(trustRelationship.createdAt).toLocaleString()}
          </div>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Updated At</span>
          <div className={styles.value}>
            {new Date(trustRelationship.updatedAt).toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustRelationshipDetailsDrawer;
